const hotels = document.getElementById('hotels');
if (hotels) {
    const children = Array.from(hotels.children);

    children.forEach(function(child) {
        let hotelId = child.getAttribute('data-hotel-id');
        let btn = document.getElementById('hotelToggleButton' + hotelId);
        let title = document.getElementById('hotelToggleTitle' + hotelId);
        let hotel = document.getElementById('hotel-' + hotelId);

        function toggle() {
            if (hotel.classList.contains('collapsed')) {
                collapseAll();
            }
            hotel.classList.toggle('collapsed');
        }

        // Collapse all
        function collapseAll() {
            children.forEach(function(child) {
                let hotelId = child.getAttribute('data-hotel-id');
                document.getElementById('hotel-' + hotelId).classList.add('collapsed');
            });
        }

        if (title) {
            title.addEventListener('click', function() {
                toggle();
            });
        }

        if (btn) {
            btn.addEventListener('click', function() {
                toggle();
            });
        }
    });
}

